import ApiService from "../../../services/ApiService";
import translate from "../../../services/Translate";

export const deleteExercises = (
  userId: number,
  exercises: Array<number>,
  language: string,
  setLoading: Function,
  resetSelection: Function,
  successCallback?: Function
) => {
  setLoading(true);

  ApiService.delete(`users/${userId}/exercises/progress/batch`, {
    exercise_ids: exercises,
  })
    .then((_) => {
      alert(translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.ALERTS.SUCCESS"));
      successCallback?.();
      resetSelection();
    })
    .catch((err) => {
      console.error("Error deleting exercises progression:", err);
      alert(translate(language, "PAGES.USER.OVERVIEW.MODULE.POPUP_PROGRESSION.ALERTS.ERROR"));
    })
    .finally(() => {
      setLoading(false);
    });
};
